import React from 'react';

export function StoreImage({imageUrl}) {
  return(
    <div className="store-front-image"
      style={{background: `url(${imageUrl}) center center / cover no-repeat`}}>
    </div>
  );
}
